$(function(){
  $('.emailInput').on('input', function() {
    $(this).attr('aria-invalid', !this.checkValidity());
  });
});
